import {
	ArchiveRestore,
	BarChart3,
	Bold,
	Check,
	Inbox,
	Italic,
	Link,
	List,
	ListOrdered,
	LogOut,
	type LucideIcon,
	Menu,
	Mic,
	MicOff,
	Pause,
	Play,
	Radio,
	Search,
	Square,
	Trash2,
	Unlink,
	Users,
	Video,
	VideoOff,
} from 'lucide-react';

import { classlist } from '~/_shared/design-system/lib/classlist';

import './icon.css';

const ICON_REGISTRY = {
	menu: Menu,
	live: Radio,
	people: Users,
	chart: BarChart3,
	'log-out': LogOut,
	search: Search,
	inbox: Inbox,
	camera: Video,
	'camera-off': VideoOff,
	mic: Mic,
	'mic-off': MicOff,
	pause: Pause,
	resume: Play,
	stop: Square,
	bold: Bold,
	italic: Italic,
	'list-bulleted': List,
	'list-numbered': ListOrdered,
	link: Link,
	'link-off': Unlink,
	trash: Trash2,
	restore: ArchiveRestore,
	check: Check,
} as const satisfies Record<string, LucideIcon>;

type IconName = keyof typeof ICON_REGISTRY;
type IconSize = 'sm' | 'md' | 'lg';

interface IconProps {
	name: IconName;
	size?: IconSize;
	className?: string;
	'aria-hidden'?: boolean;
}

const Icon = ({
	name,
	size = 'md',
	className,
	'aria-hidden': aria_hidden = true,
}: IconProps) => {
	const LucideComponent = ICON_REGISTRY[name];

	return (
		<LucideComponent
			aria-hidden={aria_hidden}
			className={classlist('icon', `icon--${size}`, className)}
		/>
	);
};

export type { IconName, IconProps, IconSize };
export { Icon };
